export default function createTerrainWorker() {
    return new Worker(new URL("./terrain.worker.js", import.meta.url), {
        type: "module",
    });
}
